import {customElement, query} from 'lit/decorators.js';
import {LitElement} from "lit";
import {SbkButton} from "@/components/button/button";
import {SbkForm} from "@/components/form/form";
import {SbkTextarea} from "@/components/textarea/textarea";
import {SbkModal} from "@/components/modal/modal";

@customElement('sbk-leadmanagement-feedback')
export class SbkLeadmanagementFeedback extends LitElement {

    @query('form')
    _form!: HTMLFormElement

    @query('#submit')
    _submitButton!: SbkButton

    @query('#cancel')
    _cancelButton!: SbkButton

    @query('sbk-textarea')
    _message!: SbkTextarea

    protected createRenderRoot() {
        return this;
    }

    constructor() {
        super();
        this._replaceContent();
    }

    connectedCallback() {
        super.connectedCallback();
        this._form.addEventListener('submit', (e) => {
            e.preventDefault()
            this._onSubmit();
        });
        this._submitButton.addEventListener('click', (e) => {
            e.preventDefault()
            this._onSubmit();
        })
        this._cancelButton.addEventListener('click', this._closeModal)
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        this._form.removeEventListener('submit', this._onSubmit);
        this._submitButton.removeEventListener('click', this._onSubmit)
        this._cancelButton.removeEventListener('click', this._closeModal)
    }

    _replaceContent() {
        const senderName: HTMLParagraphElement | null = this.querySelector(`.sender__name`)
        const senderEmail: HTMLParagraphElement | null = this.querySelector(`.sender__email`)

        fetch('/ajax/oip-creator-data')
            .then((response) => response.json())
            .then((data) => {
                const senderNameValue = `${data.first_name} ${data.last_name}`
                if (senderName)
                    senderName.innerHTML = senderNameValue
                if (senderEmail)
                    senderEmail.innerText = data.email
            })
    }

    _onSubmit() {
        const modal: SbkModal | null = this.querySelector('sbk-modal')
        if (!modal) {
            return;
        }
        const content: HTMLDivElement | null = modal.renderRoot.querySelector(`.modal__content`)

        if (!content) {
            return;
        }
        const invalidElements = SbkForm.validate(this._form);
        if (invalidElements.length) {
            const firstInvalidElement = invalidElements[0];
            firstInvalidElement.focus({preventScroll: true});
        } else {
            const formData = {
                message: this._message.value
            }

            fetch(this._form.action, {
                method: this._form.method,
                headers: {'Content-Type': 'application/json; charset=utf-8'},
                body: JSON.stringify(formData),
            }).then((response) => response.text()
            ).then((data) => {
                content.innerHTML = data + content.innerHTML
                const textarea: HTMLTextAreaElement | null | undefined = this._message?.shadowRoot?.querySelector('textarea')
                if (textarea)
                    textarea.value = ''
                this._submitButton.addEventListener('submit', (e) => {
                    e.preventDefault()
                    this._onSubmit();
                });
            })
        }
    }

    _closeModal(e: Event) {
        const modal: SbkModal | null = this.querySelector('sbk-modal')
        modal?._closeModal(e)
    }
}
